import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AccountInputSearch from "../../../../commons/components/AccountInputSearch";

import {
    accessManagementSetSearchPartner,
} from "../../../../store/actions/accessManagementActions";

import { RowFilters, ColFields, ColButtons } from './cardSearchStyles';

function CardSearch(props) {
    const dispatch = useDispatch();
    const { screens } = useSelector(state => state.userLogin);
    const { searchPartner } = useSelector(state => state.accessManagement);
    const [permissions] = useState([]);

    const [searchPartnerValue, setSearchPartnerValue] = useState(searchPartner);

    useEffect(() => {
        permissions.pop();
        if (screens.length > 0) {
            screens.map(screen => {
                if (screen.url === "/gestao-acessos") {
                    screen.functions.map(func => {
                        permissions.push(func)
                    })
                }
            });
        }
    }, [screens]);

    function handleOnSearchPartner(search) {
        dispatch(accessManagementSetSearchPartner(search));
    }

    function handleOnChangePartner(input) {
        setSearchPartnerValue(input.target.value)
    }

    return (
        <RowFilters>
            <ColFields flex="auto">
                <AccountInputSearch
                    value={searchPartnerValue}
                    placeholder="Pesquisar CNPJ ou nome da empresa"
                    style={{ width: 400, marginRight: 6 }}
                    onSearch={handleOnSearchPartner}
                    onChange={handleOnChangePartner}
                />
            </ColFields>
        </RowFilters>
    )
}

export default CardSearch;
